import IconBase from "./IconBase";

// Copy, plus: duplicating makes a new record rather than filling the clipboard.
const CloneIcon = (props) => (
    <IconBase {...props}>
        <rect x="9" y="9" width="12" height="12" rx="2.5" />
        <path d="M15 5.5v-1a2 2 0 0 0-2-2H4.5a2 2 0 0 0-2 2V13a2 2 0 0 0 2 2h1" />
        <path d="M15 12.5v5" />
        <path d="M12.5 15h5" />
    </IconBase>
);

export default CloneIcon;
